import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'

import { registerLocaleData } from '@angular/common'
import { environment } from '@front-app-environments/environment'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

import localeEs from '@angular/common/locales/es'
import localeFr from '@angular/common/locales/fr'
import localeHu from '@angular/common/locales/hu'
import localeIt from '@angular/common/locales/it'
import localePl from '@angular/common/locales/pl'
import localePt from '@angular/common/locales/pt'
import localeRu from '@angular/common/locales/ru'

registerLocaleData(localeFr)
registerLocaleData(localeIt)
registerLocaleData(localePl)
registerLocaleData(localePt)
registerLocaleData(localeHu)
registerLocaleData(localeRu)
registerLocaleData(localeEs)

if (environment.production) {
  enableProdMode()
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error('[Bootstrap] Failed to bootstrap AppComponent:', err)
})
